import React from 'react';
import { bemComponent } from '../../../../utils/app';

export const Main: React.FC<{children?: React.ReactNode}> = ({ children }) => (
    <div className="fullscreen-sidebar">
        <div className="fullscreen-sidebar__inner">{children}</div>
    </div>
);

export const Header = bemComponent('fullscreen-sidebar__header', 'Header');
export const Footer = bemComponent('fullscreen-sidebar__footer', 'Footer');

export const Body: React.FC<{children?: React.ReactNode}> = ({ children }) => (
    <div className="fullscreen-sidebar__body">
        <div className="fullscreen-sidebar__body__inner" id="fullscreenSidebar">
            {children}
        </div>
    </div>
);
